module.exports = __webpack_public_path__ + "imgs/TrevorProject.06d4c49406528372c978de4c917529b9.png";